import styled, { keyframes } from "styled-components";
import { theme } from "../../styles/theme";

export const NavBarContainer = styled.nav`
  display: ${props => (props.hide ? "none" : "flex")};
  height: 100vh;

  width: ${props => (props.isMobile ? '280px' : props.isOpen === false ? '50px' : '250px')};
  position: fixed;
  top: 0;
  left: ${props => (props.isMobile && props.isOpen === false ? '-280px' : '0')};
  
  background: ${theme.colors.gray.Cinza_1};

  transition: all 0.2s ease-out;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  
  color: #dfe4eb;
  
  z-index: 10000;
  overflow: ${props => (props.isMobile ? "" : props.isOpenMenu ? "auto" : "")};

  ::-webkit-scrollbar{ 
      width: 1px;
    }

  
`;


export const HeadMenu = styled.div`
  width: 100%;
  height: ${props => props.isOpenMenu ? '70px' : '80px'};
  display: flex;
  flex-direction: row;
  justify-content: ${props => props.isOpenMenu ? 'left' : 'center'};
  align-items: center;
  padding-left: ${props => props.isOpenMenu ? '20px' : '0px'};
  border-bottom: 1px solid #303848;
  margin-bottom: 11px;

  img {
    height: 33px;
    cursor: pointer;
  }

  @media only screen and (max-width: 780px){
    height:  ${props => props.button ? '129px' : '129px'};
    padding-inline: ${props => props.button ? '1rem' : '0'};
    flex-direction: column;
    margin: ${props => props.button && '4px 0px'};
    padding-bottom: ${props => props.button && '7px'};

    .line-1{
      display: flex;
      flex-direction: column-reverse;
      justify-content: space-evenly;
      align-items: flex-start;
      width: ${props => props.button ? '100%' : '90%'};
      height: ${props => props.button ? '50%' : '100%'};
    }

    .line-2{
      display: flex;
      flex-direction: column-reverse;
      justify-content: space-evenly;
      align-items: flex-start;
      width: ${props => props.button ? '100%' : '90%'};
      height: ${props => props.button ? '50%' : '90%'};
    }

    svg{
      margin-left: 0px;
      height: ${props => props.button ? '44px' : '90%'};
    }

  }
 
`;

export const Items = styled.div`
  width: 100%;
  height: auto;
  overflow:auto;
  padding-left: 9px;
  padding-right: 9px;
  margin-bottom: 90px;

  @media only screen and (max-height:800px){
    height: calc(100vh - 82px);
    margin-bottom: 90px;
  }

  ::-webkit-scrollbar{ 
      width: 1px;
    }
`;

export const ItemMenu = styled.div`
  width: 100%;
  /* min-width: 230px; */
  height: 40px;
  /* margin-left: 9px; */
  margin-bottom: 3px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  font-family: 'Lato';
  font-size: 10px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 1px;
  padding-left: ${props => props.isOpenMenu ? '11px' : '5px'};
  padding-right: ${props => props.isOpenMenu ? '11px' : '5px'};
  cursor: pointer;

  background-color:  ${props => props.active === true ? '#292e38' : 'transparent'};
  color: ${props => props.active === true ? `${theme.colors.white.Branco}` : '#8a92a2'};

  label {
    margin-bottom: 0px;
    width: 100%;
    cursor: pointer;
  }

  .arrow {
    width: 10px;
    transition: all 0.2s ease-out;
    transform: ${props => props.isOpen === true ? 'rotate(0deg)' : 'rotate(180deg)'};
  }

  svg {
    margin-right: ${props => props.isOpenMenu ? '15px' : '0px'};
    g {
      path {
        fill: ${props => props.active === true ? `${theme.colors.white.Branco}` : '#8a92a2'} !important;
      }
    }
  }


  p {
    width: auto;

    display:none;
    position:absolute;
    align-items: center;

    font-size: 11px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;

    padding: 6px 10px;
    color:#FFF;
    background-color: ${theme.colors.gray.Cinza_1};
    border-radius: 5px;
    opacity: 0.9;

    margin-left: 45px;
    margin-top: 17px;

    &:before{
      position: absolute;
      background-color:  ${theme.colors.gray.Cinza_1};
      width: 8px;
      height: 8px;
      top: 8px;
      margin-left: -14px;
      content: '';
      transform: rotate(45deg);
    }
  }


  &:hover{
    background-color: #292e38;
    color: #FFF;

    p{
      display: ${props => props.isOpenMenu === false ? 'block' : 'none'};
    }

    svg {
      g {
        path {
          fill: #fff !important;
        }
      }
    }
  }
`;

export const DropSubItems = styled.div`
  transition: max-height 0.5s;
  max-height: ${props => (props.open ? "1000px" : "40px" )};     
`;

export const SubItem = styled.div`
  display: ${props => props.open === true ? 'flex' : 'none'};
  
  width: 77%;
  min-width: 191px;
  height: 40px;
  margin-left: 41px;
  margin-bottom: 3px;
  border-radius: 5px;
  align-items: center;
  justify-content: space-between;

  font-family: 'Lato';
  font-size: 10px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 1px;
  padding-left: 11px;
  padding-right: 11px;
  cursor: pointer;

  background-color:  ${props => props.active === true ? '#292e38' : 'transparent'};
  color: ${props => props.active === true ? `${theme.colors.white.Branco}` : '#8a92a2'};

  label {
    margin-bottom: 0px;
    width: 100%;
    cursor: pointer;
  }

  .arrow {
    width: 10px;
    transition: all 0.2s ease-out;
    transform: ${props => props.active === true ? 'rotate(0deg)' : 'rotate(180deg)'};
  }

  svg {
    margin-right: 15px;
    g {
      path {
        fill: ${props => props.active === true ? `${theme.colors.white.Branco}` : '#8a92a2'} !important;
      }
    }
  }

  &:hover{
    background-color: #292e38;
    color: #FFF;

    svg {
      g {
        path {
          fill: #fff !important;
        }
      }
    }
  }
`;

export const FooterMenu = styled.div`
  width: 100%;
  height: ${props => props.isOpenMenu ? '90px' : '45px'};
  border-top: 1px solid #303848;
  position: absolute;
  /* padding-left: 9px;
  padding-right: 9px; */
  bottom: 0px;
`;

export const ImgGooglePlay = styled.div`
    display: flex;
    justify-content: center;
    background-color: ${theme.colors.gray.Cinza_1};
    margin-bottom: 8px;
    //margin-left: 8px;
    a:hover{
      img{
        width: 120px;
        transition: all 0.5s;
      }
    }
    img{
      width: 112px;
      margin-top: 4px;
      opacity: 0.7;
    }
    .img-2{
      margin-left: 4px;
    }
`;


export const ItemFootMenu = styled.div`
  width: 100%;
  /* min-width: 230px; */
  /* margin-left: 9px; */
  padding-top: 16px;
  padding-bottom: 16px;

  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  font-family: Lato;
  font-size: 10px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 1px;
  padding-left: 11px;
  padding-right: 11px;
  cursor: pointer;

  background-color:  ${props => props.active === true ? '#292e38' : 'transparent'};
  color: ${props => props.active === true ? `${theme.colors.white.Branco}` : '#8a92a2'};

  label {
    margin-bottom: 0px;
    width: 100%;
    cursor: pointer;
  }

  .arrow {
    width: 10px;
    transition: all 0.2s ease-out;
    transform: ${props => props.active === true ? 'rotate(0deg)' : 'rotate(180deg)'}
  }

  svg {
    margin-right: ${props => props.isOpenMenu ? '15px' : '0px'};
    g {
      path {
        fill: ${props => props.active === true ? `${theme.colors.white.Branco}` : '#8a92a2'} !important;
      }
    }
  }

  p {
    width: auto;

    display:none;
    position:absolute;
    align-items: center;

    font-size: 11px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;

    padding: 6px 10px;
    color:#FFF;
    background-color: ${theme.colors.gray.Cinza_1};
    border-radius: 5px;
    opacity: 0.9;

    margin-left: 45px;
    margin-top: 17px;

    &:before{
      position: absolute;
      background-color:  ${theme.colors.gray.Cinza_1};
      width: 8px;
      height: 8px;
      top: 8px;
      margin-left: -14px;
      content: '';
      transform: rotate(45deg);
    }
  }

  &:hover{
    color: #FFF;

    p{
      display: ${props => props.isOpenMenu === false ? 'block' : 'none'};
    }

    svg {
      g {
        path {
          fill: #fff !important;
        }
      }
    }
  }


`;

export const Terms = styled.div`
  width: 100%;
  height: 37px;
  background-color: #303848;

  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;

  label {
    color: #5bb3ff;
    font-size: 11px;
    font-weight: bold;
    margin-bottom: 0px;
    cursor: pointer;
  }
`;

export const User = styled.div`
  width: 70px;
  height: 35px;
  position: absolute;
  right: 0;
  top: ${(props) => props.isBlackNovember ? "6.4%" : "2.5%"};
  /* top: ${props => props.isMobile ? '30px' : '20px'}; */
  margin-right: ${props => props.isMobile ? '0px' : '10px'};
  padding: 0px 8px;
  z-index: 1;
  background-color: rgb(41, 46, 56);
  border: 1px solid rgb(41, 46, 56);
  border-radius: 25px;
  cursor: pointer;
  
  display: ${props => props.hide === true ? 'none' : 'flex'};
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  color: #FFF;
  font-weight: 700;

  label {
    margin: 0px;
    cursor: pointer;
    width: 30px;
    height: 28px;
    display: flex;
    border-radius: 50%;
    align-items: center;
    justify-content: center;
  }

  img{
    width: 16px;
    transform: ${props => props.showOptions ? 'rotate(360deg)' : 'rotate(180deg)'};
  }

  @media (max-width: 1920px){
    top: ${(props) => props.isBlackNovember ? "94px" : "26px"};
  }

  @media (max-width: 1530px){
    top: ${(props) => props.isBlackNovember ? "99px" : "26px"};
  }

  @media (max-width: 1182px){
    top: ${(props) => props.isBlackNovember ? "126px" : "26px"};
  }

  @media (max-width: 1024px){
    top: ${(props) => props.isBlackNovember ? "92px" : "26px"};
  }

  @media only screen and (max-width: 780px){
    display: none;

    position: relative;
    top: 0px;
    height: ${props => props.button ? '27px' : '32px'};

    img{
      width: 16px;
      height: 8px;
    }
  }

  @media only screen and (max-width: 760px){
    display: flex;

    position: relative;
    top: 0px;
    height: ${props => props.button ? '27px' : '32px'};
    background-color: #F3F3F5;
    color: ${theme.colors.gray.Cinza_2};
    
    img{
      width: 16px;
      height: 8px;
      filter: invert(1);
    }
  }
`;

export const Options = styled.div`
  display: ${props => props.show === true ? 'flex' : 'none'};
  width: 150px;
  padding: 10px 8px;
  border-radius: 10px;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  background-color: #FFF;

  z-index: 50;
  position: absolute;
  /* top: 68px; */
  top: ${props => props.isMobile ? props.button ? '85px' : '97px' : '64px'};
  right: ${props => props.isMobile ? props.button ? '90px' : '94px' : '8px'};

  /* box-shadow: 1px -3px 12px 2px rgb(29, 33, 41); */
  box-shadow: 1px 2px 5px 1px rgba(29,33,41,0.4);

  transition: all 0.2s ease-out;


  label {
    cursor: pointer;
    margin-top: 10px;
    font-size: 9px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 1px;
    color: rgb(138, 146, 162);
  }

  @media only screen and (max-width: 760px) {
    width: 176px;
  }

`;


export const Arrow = styled.div`
  display: ${props => props.show === true ? 'flex' : 'none'};
  position: absolute;
  transform: rotate(45deg);
  right: ${props => props.isMobile ? props.button ? '184px' : '210px' : '21px'};
  /* top: 64px; */
  top: ${props => props.isMobile ? props.button ? '80px' : '95px' : '62px'};
  z-index: 51;
  background-color: white;
  width: 10px;
  height: 10px;
`;

export const Help = styled.div`
  position: absolute;
  right: 7.5%;
  top: 24px;
  -webkit-box-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  align-items: center;
  cursor: pointer;
  z-index: 999;
  font-family: Lato, sans-serif;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 2px;
  fill: rgb(255, 255, 255);
  color: rgb(255, 255, 255);
  background-color: rgba(255, 255, 255, 0);
  border-radius: 50px;
  padding: 7px 12px;
  transition: all 0.2s ease-out;
  display: ${props => props.hide ? 'none' : 'flex'};

  &:hover{
    background-color: rgba(255, 255, 255, 0.17);
  }
`;

export const Plans = styled.div`
  display: ${props => props.show ? 'flex' : 'none'};
  position: absolute;
  transform: ${props => props.isMobile ? 'scale(0.8)' : 'scale(1.0)'};
  width: auto;
  height: 30px;
  font-family: Lato;
  font-size: 10px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: rgb(223, 228, 235);
  border-radius: 15px;
  background-color: rgb(88, 155, 255);
  padding-top: 9px;
  padding-left: 15px;
  padding-right: 15px;
  cursor: pointer;
  z-index: 4;
  transition: all 0.2s ease-out;

  @media only screen and (max-width: 760px){
    margin-top: 0px;
    position: absolute;
    top: 10px;
    right: 10px;
  }

  &:hover {
    background-color: rgb(88, 155, 255);
    transform: scale(0.85);
    box-shadow: 2px 2px 3px 1px rgba(88, 155, 255, 0.2);
  }
`;

export const MenuHamburg = styled.div`
  cursor: pointer;

  &::before {
    content: '';
    position: absolute;
    width: 5rem;
    height: 5rem;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
  }

  img {
    display: flex;
    position: absolute;
    top: ${(props) => {
      return `${props.hasTopBanner ? 190 : 42}px`;
    }};
    left: 15px;
    z-index: 10;
    width: 20px;
  }

  @media (max-width: 767px) {
    img {
      top: ${(props) => {
        return `${props.hasTopBanner ? 116 : 41}px`;
      }};
      left: 12px;
    }
  }

  @media (max-width: 479px) {
    img {
      top: ${(props) => {
        return `${props.hasTopBanner ? 136 : 41}px`;
      }};
      left: 12px;
    }
  }
`;


export const Notification = styled.div`

  @keyframes treme {
    0% {transform: rotate(0deg);}
    25% {transform: rotate(30deg);}
    50% {transform: rotate(0deg);}
    75% {transform: rotate(-30deg);}
    100% {transform: rotate(0deg);}
  }
  
  @keyframes up {
    0% {transform: rotate(0deg);}
    25% {transform: rotate(30deg);}
    50% {transform: rotate(0deg);}
    75% {transform: rotate(-30deg);}
    100% {transform: rotate(0deg);}
  }
  
  @keyframes down {
    0% {transform: rotate(0deg);}
    25% {transform: rotate(30deg);}
    50% {transform: rotate(0deg);}
    75% {transform: rotate(-30deg);}
    100% {transform: rotate(0deg);}
  }



  display: ${props => props.show ? 'flex' : 'none'};
  position: absolute;
  top: ${(props) => props.isBlackNovember ? "7%" : "3.5%"};
  /* top: ${props => props.isMobile ? '43px' : '29px'}; */
  right: ${props => props.isMobile ? '23px' : '94px'};
  width: 20px;
  height: 20px;

  cursor: pointer;
  z-index: 4;
  transition: all 0.2s ease-out;


  svg {
    animation: ${props => props.tremer ? 'treme 0.25s' : ''};
    animation-iteration-count: 2;
    transition-timing-function: ease-out;

    g {
      g {
        fill: ${props => props.active === true ? `${theme.colors.white.Branco}` : '#8a92a2'} !important;
      }
    }
  }

  &:hover {

    transform: scale(1.12);
    
    svg {
      animation: ${props => props.tremer ? 'up 0.2s' : ''};
      animation-iteration-count: 1;
      transition-timing-function: ease-out;
      g {  
        g {
          fill: #fff !important;
        }
      }
    }
  }

  @media (max-width: 1920px){
    top: ${(props) => props.isBlackNovember ? "101px" : "33px"};
  }

  @media (max-width: 1530px){
    top: ${(props) => props.isBlackNovember ? "106px" : "33px"};
  }

  @media (max-width: 1182px){
    top: ${(props) => props.isBlackNovember ? "136px" : "29px"};
  }

  @media (max-width: 1024px){
    top: ${(props) => props.isBlackNovember ? "99px" : "34px"};
  }

  @media (max-width: 760px){
    top: ${(props) => props.isBlackNovember ? "192px" : "54px"};
  }

  @media (max-width: 550px){
    right: 12px;
    top: ${(props) => props.isBlackNovember ? "205px" : "56px"};
  }

  @media (max-width: 479px){
    right: 12px;
    top: ${(props) => props.isBlackNovember ? "232px" : "54px"};
  }
`;

export const Upgrade = styled.div`
  display: ${props => props.show ? 'flex' : 'none'};
  justify-content: center;
  position: absolute;
  /* top: ${props => props.isMobile ? '28px' : '23px'}; */
  top: ${(props) => props.isBlackNovember ? "80px" : "37px"};
  right:${(props) => props.isBlackNovember ? '118px' : '210px'};
  /* right: ${props => props.isMobile ? '52px' : '113px'}; */
  width: 120px;
  height: 30px;
  font-family: Lato;
  font-size: 10px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #FFF;
  border-radius: 15px;
  background-color: ${props => props.isMobile ? 'transparent' : 'rgb(48, 56, 72)'};
  padding-top: 9px;
  /* padding-left: 15px;
  padding-right: 15px; */

  cursor: pointer;
  z-index: 4;
  transition: all 0.2s ease-out;

  @media only screen and (max-width: 760px){
    width: 30px;
  }

  p{
    cursor: pointer;
  }

  #diamond {
    fill: #8a92a2 !important;
  }

  &:hover {

    transform: scale(1.06);
    color: #FFF;
    /* box-shadow: 2px 2px 3px 1px rgba(88, 155, 255, 0.2); */

    #diamond {
      fill: #fff !important;
    }

    svg {
      path{
        
      }
    }
  }

  @media (max-width: 1920px){
    right:${(props) => props.isBlackNovember ? '118px' : '210px'};
    top: ${(props) => props.isBlackNovember ? "97px" : "29px"};
  }

  @media (max-width: 1530px){
    top: ${(props) => props.isBlackNovember ? "101px" : "29px"};
  }

  @media (max-width: 1182px){
    top: ${(props) => props.isBlackNovember ? "129px" : "29px"};
  }

  @media (max-width: 1024px){
    top: ${(props) => props.isBlackNovember ? "96px" : "29px"};
  }

  /* @media (max-width: 760px){
    top: ${(props) => props.isBlackNovember ? "192px" : "54px"};
  }

  @media (max-width: 550px){
    right: 12px;
    top: ${(props) => props.isBlackNovember ? "205px" : "56px"};
  }

  @media (max-width: 479px){
    right: 12px;
    top: ${(props) => props.isBlackNovember ? "232px" : "54px"};
  } */
`;

export const ButtonNewP = styled.div`
  display: ${props => props.show ? 'flex' : 'none'};
  position: absolute;
  top: ${(props) => props.isBlackNovember ? "6.5%" : "3%"};
  /* top: ${props => props.isMobile ? '28px' : '23px'}; */
  right: ${props => props.isMobile ? '36px' : props.isPro || props.isTest ? '125px' : '246px'};
  width: auto;
  height: 30px;
  font-family: Lato;
  font-size: 10px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #FFF;
  border-radius: 15px;
  background-color: ${props => props.isMobile ? 'transparent' : `${theme.colors.green.Verde_AgroReceita}`};
  padding-top: 9px;
  padding-left: 15px;
  padding-right: 15px;

  cursor: pointer;
  z-index: 4;
  transition: all 0.2s ease-out;

  #diamond {
    fill: #8a92a2 !important;
  }

  &:hover {

    transform: scale(1.06);
    color: #FFF;
    box-shadow: 2px 2px 3px 1px rgba(47, 187, 105, 0.2);

    #diamond {
      fill: #fff !important;
    }

    svg {
      path{
        
      }
    }
  }

  @media (max-width: 1920px){
    top: ${(props) => props.isBlackNovember ? "97px" : "29px"};
  }

  @media (max-width: 1530px){
    top: ${(props) => props.isBlackNovember ? "102px" : "29px"};
  }

  @media (max-width: 1182px){
    top: ${(props) => props.isBlackNovember ? "129px" : "29px"};
  }

  @media (max-width: 1024px){
    top: ${(props) => props.isBlackNovember ? "95px" : "29px"};
  }
`;

export const NumNotifications = styled.div`
  position: absolute;
  background-color: ${theme.colors.red.Vermelho_erro};
  width: 16px;
  height: 16px;
  color: #FFF;
  font-size: 9.6px;
  font-weight: 900;
  border: 1px solid #ff5252;
  border-radius: 50%;
  text-align: center;
  top: -6px;
  left: 9px;
`;

export const BtnMinimize = styled.div`
  position: fixed;
  width: 20px;
  height: 20px;
  z-index: 10001;
  top: 58px;
  left: ${props => (props.isOpen === false ? '40px' : '240px')};
  border: 1px solid transparent;
  border-radius: 50%;
  background-color: #292e38;
  transition: all 0.2s ease-out;
  box-shadow: 1px 2px 5px 1px rgb(29 33 41 / 40%);
  cursor: pointer;

  &:hover {
    transform: scale(1.1);
  }

  &:active {
    transform: scale(0.9);
  }

  @media only screen and (max-width: 780px) {
    top: 78px;
  }
`;

export const Button = styled.button`
     padding: 0.625rem 1.25rem;
     
     color: #fff;
     border: none;
     cursor: pointer;
     border-radius: 0.313rem;
     background-color: #007BFF;
`;

export const Container = styled.div`
  width: 100%;
  height: auto;
  max-width: 28.75rem;

  >img{
      @media (max-width: 480px) {
            width: 8rem;
      }
    }

  >h5{
      margin-top: 1rem;

      @media (max-width: 480px) {
          font-size: 1.4rem;
      }
  }

  >p{
     margin-top: 1rem;

      >span{
        @media (max-width: 480px) {
          font-size: 1rem;
        }
      }

     @media (max-width: 480px) {
          font-size: 1rem;
      }
  }

  >p:nth-of-type(2){
      margin-top: 0.5rem;

      @media (max-width: 480px) {
            font-size: 0.9rem;
            line-height: 1rem;
      }
  }

    >div >div {
        >div:nth-of-type(1) {}

        >div:nth-of-type(2) {
          margin-bottom: 0;      
        }
    }
`;

export const ButtonPlans = styled.div`
     width: 100%;
     display: flex;
     margin-top: 1.25rem;
     margin-bottom: 0.938rem;
     flex-direction: row;
     justify-content: center; 
`;

export const ContainerNotification = styled.button`
    all: unset;

    position: relative;

    width: 3rem;
    height: 3rem;

    display: flex;
    align-items: center;
    justify-content: center;

    > a {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    img {
        width: 1.25rem;
        height: 1.25rem;

        cursor: pointer;
        border-radius: 10rem;
        filter: invert(1);
    }

    @media (max-width: 760px) {
      img {
        filter: none;
      }
    }
`;

export const ContainerProfileAndNotification = styled.div`
  width: auto;
  height: 48px;

  position: absolute;
  /* hasPromo (banner de contagem regressiva, ex: Semana do Cliente) e
     hasTopBanner (banner de alerta via /alertas) empurram o header pra baixo
     do mesmo jeito — sem checar os dois, o widget ficava colado no topo
     (20px) sempre que só o banner de contagem regressiva estava visível. */
  top: ${({ hasTopBanner, hasPromo }) => (hasTopBanner || hasPromo) ? '105px' : '20px'};
  right: 25px;
  z-index: 2;

  display: flex;
`;

export const ContainerProfile = styled.div`
  width: auto;
  
  position: relative;
`;

export const ContainerNotificationV2 = styled.button`
    all: unset;

    position: relative;

    width: 3rem;
    height: 3rem;

    display: flex;
    align-items: center;
    justify-content: center;

    > a {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;

        > img {
            width: 1.25rem;
            height: 1.25rem;
            cursor: pointer;
            border-radius: 10rem;
            filter: brightness(0.4);
        }
    }

    @media (max-width: 760px) {
        display: none;
    }
`;

export const NotificationBadge = styled.div`
  width: 6px;
  height: 6px;
  background-color: red;
  border-radius: 50%;
  position: absolute;
  right: 15px;
`;

const notifPulse = keyframes`
  0%, 100% {
    box-shadow: 0 0 0 0 rgba(255, 82, 82, 0.7);
  }
  50% {
    box-shadow: 0 0 0 5px rgba(255, 82, 82, 0);
  }
`;

export const NotifCountBadge = styled.span`
  position: absolute;
  top: -6px;
  right: -8px;

  min-width: 17px;
  height: 17px;
  padding: 0 3px;

  display: flex;
  align-items: center;
  justify-content: center;

  background-color: ${theme.colors.red.Vermelho_erro};
  border-radius: 50px;

  font-family: 'Lato', sans-serif;
  font-size: 9px;
  font-weight: 900;
  color: #fff;
  line-height: 1;

  animation: ${notifPulse} 2s ease-in-out infinite;
`;